<template>

  <div style="width:100%"
       :style="{'color':color}">
    <div class="flex top_title">{{data.title}}</div>
    <div class="flex content">{{data.content}}</div>
  </div>

</template>
<script>
export default {
  props: {
    data: { type: Object, default: { return: {} } },
    color: { type: String, default: { return: '#fff' } }
  },
  data () {
    return {

    }
  }
}
</script>
<style lang="less" scoped>
.top_title {
  // color: #fff;
  font-size: 37px;
  text-align: center;
  font-weight: bold;
  margin: 20px 0 12px 0;
}
.content {
  font-size: 16px;
  // color: #fff;
  text-align: center;
}
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
}
</style>